import React from 'react';
import '../styles/HeroSection.css';

const HeroSection = () => (
  <div className="hero-section">
    <h1>Doug Fauth</h1>
    <p>Solving tomorrow's problems today one byte at a time</p>
  </div>
);
export default HeroSection;